import React from 'react';
import Navbar from '../components/Navbar';
import VideoHero from '../components/VideoHero';
import './Dream90.css';

const Dream90 = () => {
  return (
    <div className="dream90-page">
      <Navbar />
      <VideoHero videoSrc="/Dream 90.mp4" />

      {/* Digital Library Section */}
      <section className="digital-library-section">
        <div className="container">
          <div className="section-header">
            <h2>Digital Library</h2>
            <p>Access comprehensive study materials and resources for ICSE and CBSE boards</p>
          </div>
          
          {/* ICSE Section */}
          <div className="board-section">
            <h3 className="board-title">ICSE Resources</h3>
            <div className="library-grid">
              <div className="library-card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <div className="library-card-content">
                <h3>ICSE 10TH</h3>
                <p>Complete study materials and previous year papers for Class 10</p>
                </div>
              </div>
              
              <div className="library-card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>ICSE 9TH</h3>
                <p>Detailed notes and practice materials for Class 9</p>
              </div>
              
              <div className="library-card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>ICSE 8TH</h3>
                <p>Essential study resources and worksheets for Class 8</p>
              </div>
            </div>
          </div>

          {/* CBSE Section */}
          <div className="board-section">
            <h3 className="board-title">CBSE Resources</h3>
            <div className="library-grid">
              <div className="library-card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>CBSE 10TH</h3>
                <p>Complete study materials and sample papers for Class 10</p>
              </div>
              
              <div className="library-card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>CBSE 9TH</h3>
                <p>Comprehensive notes and practice materials for Class 9</p>
              </div>
              
              <div className="library-card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>CBSE 8TH</h3>
                <p>Essential study resources and practice sheets for Class 8</p>
              </div>
            </div>
          </div>

          {/* Competitive Exam Section */}
          <div className="board-section">
            <h3 className="board-title">Competitive Exam Resources</h3>
            <div className="library-grid">
              <div className="library-card">
                <div className="card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>SCIENCE COMPETITIVE<br />EXAM SAMPLE PAPER</h3>
                <p>Practice papers and study materials for competitive science exams</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dream90; 